import { CustomRoutes } from '@shared/consts/routes/custom-routes.const';
import { ProjectContactsListComponent } from '@project-modules/project-contacts/pages/project-contacts-list-component/project-contacts-list.component';

export const ProjectContactsRoutes: CustomRoutes = [
  {
    path: '',
    component: ProjectContactsListComponent
  }
];
